import { ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useGlobalData } from "./GlobalContext";
import React from "react";
import { isPC, obs } from "@/utils";
import { Button } from "@material-tailwind/react";
import { copyToClipboard } from "@/utils/clipboard";
import { WeChat, Drag, FullScreen } from "../svg";
import Iconify from "../common/Iconify";
import { Question } from "@/pages/word/question";
import { useUserStore } from "@/store/user";

export const AppChat = () => {
  const { appInfo, showChat, setShowChat, utils } = useGlobalData();
  const [loaded, setloaded] = React.useState(false);
  const [loadSuccess, setLoadSuccess] = React.useState(false);
  const element = React.useRef<HTMLDivElement>(null);
  const [draging, setDraging] = React.useState(false);
  React.useEffect(() => {
    if (showChat) {
      setloaded(true);
      if (element.current) {
        element.current.style.display = "block";
      }
    }
  }, [showChat]);

  return (
    <div className="w-full h-full relative">
      {loaded && (
        <iframe
          onLoad={() => {
            setLoadSuccess(true);
          }}
          className={`w-full h-full ${draging ? "hidden" : "block"}`}
          src={appInfo?.aiAddress + ""}
        ></iframe>
      )}
    </div>
  );

  return loaded ? (
    <div
      ref={element}
      onAnimationEnd={() => {
        if (!showChat) {
          element.current!.style.display = "none";
        }
      }}
      className={`${
        showChat ? "chat-in" : "chat-out"
      } backdrop-blur-xl bg-white/30  w-[400px]  h-[750px] fixed bottom-5 right-5 z-[100] shadow-black/20 shadow-xl rounded-md overflow-hidden`}
    >
      <div className=" h-8 inline-flex items-center absolute top-3 right-3">
        <div
          onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => {
            e.preventDefault(); // Prevent text selection
            setDraging(true);
            const startX = e.clientX;
            const startY = e.clientY;
            const startLeft = element.current?.offsetLeft ?? 0;
            const startTop = element.current?.offsetTop ?? 0;

            let lastUpdateTime = 0;
            const minUpdateInterval = 16; // ~60fps

            const onMouseMove = (e: MouseEvent) => {
              const currentTime = Date.now();
              if (currentTime - lastUpdateTime < minUpdateInterval) return;

              const newLeft = startLeft + e.clientX - startX;
              const newTop = startTop + e.clientY - startY;

              if (element.current) {
                element.current.style.left = `${newLeft}px`;
                element.current.style.top = `${newTop}px`;
              }

              lastUpdateTime = currentTime;
            };

            const onMouseUp = () => {
              setDraging(false);
              document.removeEventListener("mousemove", onMouseMove);
              document.removeEventListener("mouseup", onMouseUp);
            };

            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
          }}
          className="w-8 h-8 cursor-grab flex items-center justify-center"
        >
          <Drag className="w-[26px] h-[26px]" />
        </div>
        <div
          onClick={() => {
            setShowChat(false);
            setTimeout(() => {
              window.open(appInfo?.aiAddress);
            }, 300);
          }}
          className="w-8 h-8 cursor-pointer flex items-center justify-center"
        >
          <FullScreen className="w-8 h-8" />
        </div>
        <div
          onClick={() => setShowChat(false)}
          className="w-8 h-8 cursor-pointer flex items-center justify-center"
        >
          <div className="w-5 h-1 bg-gray-800 rounded-sm"></div>
        </div>
      </div>

      <iframe
        className={`w-full h-full ${draging ? "hidden" : "block"}`}
        src={appInfo?.aiAddress + ""}
      ></iframe>
    </div>
  ) : (
    <div></div>
  );
};

export const WechatMain = () => {
  const Global = useGlobalData();

  return (
    <>
      <img
        className="w-52  mx-auto mt-3"
        src={obs(Global.appInfo?.wxImage)}
        alt=""
      />
      {!!Global.appInfo?.wxNumber && (
        <div className="flex justify-center items-center mt-3">
          <span>{Global.appInfo?.wxNumber}</span>
          <Button
            onClick={() => {
              copyToClipboard({
                text: Global.appInfo?.wxNumber!,
                success() {
                  Global.alert({
                    color: "green",
                    message: "复制成功",
                  });
                  Global.setConfirmModal(false);
                },
              });
            }}
            className="ml-5 flex items-center gap-2"
            size="sm"
          >
            <WeChat />
            点击复制
          </Button>
        </div>
      )}
    </>
  );
};

export const BottomButton = () => {
  const Global = useGlobalData();
  const userStore = useUserStore();
  const url = Global.appInfo?.navigationMenu?.find(
    (item) => item.title == "AI口语外教"
  )?.path;
  const [oralTeacherClosed, setOralTeacherClosed] = React.useState(false);

  React.useEffect(() => {
    const closed = localStorage.getItem("oralTeacherClosed");
    if (closed === "true") {
      setOralTeacherClosed(true);
    }
  }, []);

  const handleCloseOralTeacher = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOralTeacherClosed(true);
    localStorage.setItem("oralTeacherClosed", "true");
  };
  const handleGetWechat = () => {
    Global.confrim({
      footer: false,
      showCancel: true,
      message: (
        <div>
          {Global.appInfo?.wxContent.split("\n").map((item, index) => (
            <div key={index} className="text-blue-gray-700 font-medium mb-2">
              {item}
            </div>
          ))}

          <WechatMain />
        </div>
      ),
      title: <div className="text-center text-blue-gray-900">提示</div>,
    });
  };
  
  function Chat() {
    return (
      !!Global.appInfo?.aiAddress && (
        <div
          onClick={() => {
            if (!Global.userInfo) {
              return Global.setLoginModal(true);
            }

            if (isPC()) {
              Global.setShowChat(!Global.showChat);
            } else {
              window.open(Global.appInfo?.aiAddress);
            }
          }}
          id="ai"
          style={{
            borderRadius: Global.showChat ? "10px 0px 0px 10px" : "100px",
          }}
          className={`${
            Global.showChat
              ? "-right-20 bg-gray-50 dark:bg-black/40 w-8"
              : "bg-white dark:bg-blue-gray-900 w-16"
          } h-16 cursor-pointer rounded-[100px] rounded-r-0 relative   flex justify-center items-center shadow-md`}
        >
          {Global.showChat ? (
            <ChevronRightIcon className="w-6 h-7 dark:text-white" />
          ) : (
            <Iconify
              icon="hugeicons:chat-gpt"
              className="text-black dark:text-gray-200 "
              size={40}
            />
          )}
        </div>
      )
    );
  }

  return userStore.isMP ? (
    <div></div>
  ) : (
    <div className="w-16 h-auto bottom-3 -left-[5rem] md:bottom-10 md:-left-[7rem] absolute z-50">
      {!!url && !oralTeacherClosed && (
        <div
          onClick={() => {
            window.location.href = url;
          }}
          className=" shadow cursor-pointer w-16 relative h-16  rounded-xl flex items-center justify-center  mb-5"
        >
          <img
            className="w-10 absolute -top-4 -left-2"
            src={obs(
              "https://minio.jiaojq.vip/app/base/06-02/b30b6d73921f685d5f2aaccdf2db1ffa.webp"
            )}
          />
          <img
            className="w-full h-full rounded-xl"
            src={obs("https://minio.jiaojq.vip/app/base/06-01/aiwaijiao.jpg")}
            alt=""
          />
          <div className="rounded-b-xl absolute bottom-0 left-0 w-full h-5 flex items-center justify-center text-[12px] text-gray-900 font-bold bg-white/80">
            口语外教
          </div>
          {/* 关闭按钮 */}
          <div
            onClick={handleCloseOralTeacher}
            className="absolute -top-1  -right-1 w-5 h-5 flex items-center justify-center bg-gray-700 rounded-full  hover:bg-gray-900 z-10"
            title="关闭"
          >
            <XMarkIcon className="w-4 text-white " />
          </div>
        </div>
      )}
      {/* 其余原有内容保持不变 */}
      <Question />
      {Chat()}
      {!!Global.appInfo?.showWeChat && (
        <div
          onClick={() => handleGetWechat()}
          className="w-16 h-16 cursor-pointer rounded-[100px] mt-5 bg-blue-gray-900 flex justify-center items-center shadow-md"
        >
          <WeChat className="w-8 h-8" />
        </div>
      )}
    </div>
  );
};
